import type { ReactNode } from "react";

/** Flex row with standard padding + divider below — used above tables. */
export function Toolbar({ children }: { children: ReactNode }) {
  return <div className="table-toolbar">{children}</div>;
}
